import { isEmptyString } from '@impuls-coach/util-is';
import i18n from 'helper/i18n';
import { VALIDATE_IS_NOT_ALLOWED, VALIDATE_IS_NOT_RECOMMENDED } from 'helper/validator';
import moment from 'moment';

const validRegexp = /^\d{1,2}\.\d{1,2}\.\d{4}$/g;

export const isValidDate = (value: string): boolean => {
	const dateParts: Array<string> = value.split('.');
	if (dateParts.length < 3) {
		return false;
	}
	const day: number = parseInt(dateParts[0], 10);
	const month: number = parseInt(dateParts[1], 10);

	return Boolean(day >= 1 && day <= 31 && month >= 1 && month <= 12);
};

const ExceededAges = {
	Min: 16,
	FullRights: 18,
	Max: 115,
};

export default (inputValue: string): Promise<any> => {
	return new Promise((resolve: Function, reject: Function) => {
		if (isEmptyString(inputValue)) {
			return reject({
				type: '',
				message: '',
			});
		}

		if (!inputValue.match(validRegexp) || !isValidDate(inputValue)) {
			return reject({
				type: VALIDATE_IS_NOT_ALLOWED,
				message: i18n('react.impulsCoach.components.anamnesis.determineAge.validation.invalidFormat'),
			});
		}

		const diff = moment().diff(moment(inputValue, 'DD.MM.YYYY'), 'years');

		if (diff < ExceededAges.Min) {
			return reject({
				type: VALIDATE_IS_NOT_ALLOWED,
				message: i18n('react.impulsCoach.components.anamnesis.determineAge.validation.impossibleToTakePart'),
			});
		}

		if (diff > ExceededAges.Max) {
			return reject({
				type: VALIDATE_IS_NOT_ALLOWED,
				message: i18n('react.impulsCoach.components.anamnesis.determineAge.validation.maxAgeExceeded'),
			});
		}

		if (diff >= ExceededAges.Min && diff < ExceededAges.FullRights) {
			return reject({
				type: VALIDATE_IS_NOT_RECOMMENDED,
			});
		}

		return resolve();
	});
};
